import { View } from "react-native";
import { Text } from "react-native-paper";
import { ScreenContainer, ActionsContainer, Button } from "../../components";
import LottieView from "lottie-react-native";
import { ScreenProps } from "../types";

export default function ApplicationSubmittedScreen({ route, navigation }: ScreenProps<"JobApplySuccess">) {
  const { companyName } = route.params;

  function handleClose() {
    // 1 is application form
    // 2 is job details
    // 3 is search results *or* recommended list
    navigation.pop(3);
  }

  return (
    <ScreenContainer>
      <View className="flex-grow justify-center items-center p-9">
        <View className="w-28 h-28 mb-12">
          <LottieView style={{ flex: 1 }} autoPlay source={require("../../../assets/lottie-icons/verified.json")} />
        </View>
        <Text className="text-title-3 font-700 text-ink-darkest mb-5 text-center">Application Submitted</Text>
        <Text className="text-regular-normal font-400 text-ink-dark mb-5 text-center">
          Your applications has been submitted to {companyName}.
        </Text>
        <Text className="text-regular-normal font-400 text-ink-dark text-center">
          PGA Career Services does not receive or review resumes or participate in the hiring process. All follow up and further
          communication will be administered by the employer.
        </Text>
      </View>
      <ActionsContainer hideBorder>
        <Button mode="secondary" onPress={handleClose}>
          Close
        </Button>
      </ActionsContainer>
    </ScreenContainer>
  );
}
